import { ReportSaveMode } from '@/types';

export * from './queryKeys';
export * from './apiBaseUrl';
export * from './apiRoutes';

export const breadcrumbs = [
  { name: 'Home', path: '/home' },
  { name: 'Prospecting List', path: '/' },
];

export const DEFAULT_PAGE_SIZE = 10;

export const REPORT_LIST_TYPE_OPTIONS = [
  {
    label: 'Static',
    value: ReportSaveMode.CreditUnion,
  },
  {
    label: 'Dynamic',
    value: ReportSaveMode.Configuration,
  },
];
